import React, { useState } from "react";
import "./EmailAuth.css";

const EmailAuth = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [otpSent, setOtpSent] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);

  // Function to simulate OTP generation and sending
  const sendOtp = () => {
    const generatedOtp = Math.floor(100000 + Math.random() * 900000); // Generate a 6-digit OTP
    setOtpSent(generatedOtp);
    setIsOtpSent(true);
    alert(`OTP sent to ${email}: ${generatedOtp}`);
  };

  // Function to verify OTP
  const verifyOtp = (e) => {
    e.preventDefault();
    if (otp === otpSent.toString()) {
      setOtpVerified(true);
      alert("OTP Verified successfully!");
    } else {
      alert("Invalid OTP, please try again.");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Email Authentication with OTP</h2>

        {/* Email input form */}
        {!isOtpSent && !otpVerified ? (
          <form onSubmit={(e) => e.preventDefault()} className="auth-form">
            <label htmlFor="email">Enter your Email:</label>
            <input
              type="email"
              id="email"
              placeholder="example@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="button" onClick={sendOtp}>
              Send OTP
            </button>
          </form>
        ) : null}

        {/* OTP verification form */}
        {isOtpSent && !otpVerified ? (
          <form onSubmit={verifyOtp} className="auth-form">
            <label htmlFor="otp">Enter OTP:</label>
            <input
              type="text"
              id="otp"
              placeholder="Enter 6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />
            <button type="submit">Verify OTP</button>
          </form>
        ) : null}

        {/* Success message */}
        {otpVerified && (
          <div className="success-message">
            <h3>OTP Verified!</h3>
            <p>Authentication successful for email: {email}</p>
            <a href="/dashboard" className="ok"> <button>OK</button></a>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailAuth;
